import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=2b312dfb&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"
import style0 from "./Content.vue?vue&type=style&index=0&id=2b312dfb&prod&scoped=true&lang=css"
import style1 from "./Content.vue?vue&type=style&index=1&id=2b312dfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b312dfb",
  null
  
)

export default component.exports